module.exports = __webpack_public_path__ + "static/media/alycore01.ee13a199.png";